/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineLucky.vue?vue&type=template&id=4b467f5a&scoped=true"
import script from "./popMineLucky.vue?vue&type=script&lang=js"
export * from "./popMineLucky.vue?vue&type=script&lang=js"
import style0 from "./popMineLucky.vue?vue&type=style&index=0&id=4b467f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b467f5a",
  null
  
)

export default component.exports